Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
function getAssetName(asset) {
    // remove the extension from the asset name
    return asset.split('.')[0];
}
function getAssetUrl(asset) {
    // create placeholder reference url for the asset
    return 'prefetch:///' + asset;
}
function prefetchAsset(asset) {
    var client = require('../ScriptManager/index.js');
    var ScriptManager = client.ScriptManager, getWebpackContext = client.getWebpackContext;
    // caller should be undefined when fetching/loading the remote entry container
    var caller = asset.name === asset.remoteName ? undefined : asset.remoteName;
    return ScriptManager.shared.prefetchScript(asset.name, caller, getWebpackContext(), asset.url);
}
var RepackPrefetchPlugin = ()=>({
        name: 'repack-prefetch-plugin',
        generatePreloadAssets: (args)=>_async_to_generator._(function*() {
                var preloadConfig = args.preloadOptions.preloadConfig;
                var remoteName = preloadConfig.nameOrAlias;
                var remoteSnapshot = args.remoteSnapshot;
                if (preloadConfig.depsRemote !== false) {
                    console.warn('[RepackPrefetchPlugin] ' + 'The depsRemote configuration option is not implemented yet. ' + 'This setting will be ignored and will have no effect. ' + 'You can hide this warning by setting depsRemote explicitly to false.');
                }
                function handleAssets(assets) {
                    return assets.map((asset)=>({
                            name: getAssetName(asset),
                            remoteName,
                            url: getAssetUrl(asset)
                        }));
                }
                var assets = [];
                if ('modules' in remoteSnapshot) {
                    for (var exposedModule of remoteSnapshot.modules){
                        if (preloadConfig.exposes) {
                            if (!preloadConfig.exposes.includes(exposedModule.moduleName)) {
                                continue;
                            }
                        }
                        if (preloadConfig.resourceCategory === 'all') {
                            var _assets, _assets1;
                            (_assets = assets).push.apply(_assets, _to_consumable_array._(handleAssets(exposedModule.assets.js.async)));
                            (_assets1 = assets).push.apply(_assets1, _to_consumable_array._(handleAssets(exposedModule.assets.js.sync)));
                        } else if (preloadConfig.resourceCategory === 'sync') {
                            var _assets2;
                            (_assets2 = assets).push.apply(_assets2, _to_consumable_array._(handleAssets(exposedModule.assets.js.sync)));
                        }
                    }
                    if (preloadConfig.filter) {
                        assets = assets.filter((asset)=>preloadConfig.filter(asset.name));
                    }
                    assets.unshift({
                        name: remoteSnapshot.globalName,
                        remoteName: remoteSnapshot.globalName,
                        url: getAssetUrl(remoteSnapshot.remoteEntry)
                    });
                }
                yield Promise.all(assets.map(prefetchAsset));
                // noop for compatibility
                return Promise.resolve({
                    cssAssets: [],
                    jsAssetsWithoutEntry: [],
                    entryAssets: []
                });
            })()
    });
var _default = RepackPrefetchPlugin;
